import iframeMessenger from 'iframe-messenger'

var el = document.createElement('script');
el.src = `https://interactive.guim.co.uk/2021-embeds/2021/euro-locator/embed/app.js` //'https://interactive.guim.co.uk/2021-embeds/2021/euro-locator/embed/v/1620813718395/app.js';
document.body.appendChild(el);


setTimeout(() => {
  if (window.resize) {  


    console.log('resizing ...')

    const html = document.querySelector('html')
    const body = document.querySelector('body')
  
    html.style.overflow = 'hidden'
    html.style.margin = '0px'
    html.style.padding = '0px'
  
    body.style.overflow = 'hidden'
    body.style.margin = '0px'
    body.style.padding = '0px'
  
  window.resize()
  }
},100)


iframeMessenger.enableAutoResize();